<template>
    <div id="contents" class="contents plan-your-visit">

        <div class="breadcrumb">
            <ul>
                <li><router-link :to="{name: 'Index'}">TOP</router-link></li>
                <li>VR Videos</li>
            </ul>
        </div>

        <h1 class="ttl">Virtually Visit Japan Heritage Sites</h1>

        <div class="grayBox">
            <div class="inner">

                <h2 class="ttl">Mountain Deities and the Sacred Land of the Indigenous Ainu</h2>
                <div class="article">
                    <ul>
                        <li v-on:click="openVr('hXNdis7QdRE')">
                            <div class="img">
                                <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_055_001_005.jpg" alt=""></figure>
                                <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Daisetsuzan and the Sounkyo Gorge </p></div>
                        </li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                    </ul>
                </div>

                <h2 class="ttl">Policemen Pirates of the Setonaikai Sea</h2>
                <div class="article">
                    <ul>
                        <li v-on:click="openVr('JJRfzmf3ipU')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_036_001_002.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Noshima Castle Ruins</p></div>
                        </li>
                        <li v-on:click="openVr('8EI5lfeoop8')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_036_001_006.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Mt. Shirataki and the Gohyaku Rakan (500 Arhat Statues)</p></div>
                        </li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                    </ul>
                </div>

                <h2 class="ttl">A Buddhist Pilgrimage off the Beaten Track</h2>
                <div class="article">
                    <ul>
                        <li v-on:click="openVr('jTYLjqM0yj8')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_021_001_002.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Ouchi-Juku</p></div>
                        </li>
                        <li v-on:click="openVr('2B-tn7Bi8JE')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_021_001_003.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Sakudari Kannon-do Hall</p></div>
                        </li>
                        <li v-on:click="openVr('wgMKB84WBC4')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_021_001_004.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Sazaedo Temple</p></div>
                        </li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                    </ul>
                </div>

                <h2 class="ttl">The Cradle of Japanese Porcelain</h2>
                <div class="article">
                    <ul>
                        <li v-on:click="openVr('mfPs4O1gwEU')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_037_001_005.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Shida-yaki Pottery Factory Museum</p></div>
                        </li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                    </ul>
                </div>

                <h2 class="ttl">A Historic Port City Perfect for Wandering</h2>
                <div class="article">
                    <ul>
                        <li v-on:click="openVr('Yn8dk04tirc')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_014_001_002.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Onomichi’s narrow hillside streets</p></div>
                        </li>
                        <li v-on:click="openVr('aa-q3JttBXM')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_014_001_003.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Senkoji Temple</p></div>
                        </li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                    </ul>
                </div>

                <h2 class="ttl">Exploring the Birthplace of the Real Ninja</h2>
                <div class="article">
                    <ul>
                        <li v-on:click="openVr('Z0TbJi7Yl3o')">
                            <div class="img">
                                    <figure><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/VR960/jh_vt_042_001_003.jpg" alt=""></figure>
                                    <p class="btn-play"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/assets/icon-play.svg" alt=""></p>
                            </div>
                            <div class="txt"><p>Iga Ueno Castle</p></div>
                        </li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                        <li class="blank"></li>
                    </ul>
                </div>

            </div>
        </div>
        <vr-player ref="vr"></vr-player>
    </div>
</template>

<script>
    import VrPlayer from "../../components/VrPlayer/VrPlayer";
    import ApiRouter from "../../components/Systems/ApiRouter";

    export default {
        name: "VRMovies",
        components: {VrPlayer},
        mixins: [ApiRouter],
        data: function () {
            return {
                articles: []
            }
        },
        created: function () {
            this.loadData();
            document.title = 'VR Videos | Japan Heritage Official Site'
        },
        methods: {
            loadData: function () {
                window.axios.get(this.routes.articles)
                    .then((response) => {
                        this.articles = response.data.data;
                    });
            },
            articleCardHasClicked: function (id, hash) {
                this.$router.push({name: 'Popular', params: {id: id, page: 'travelInfo'}, hash: hash});
            },
            openVr: function ($event) {
                this.$refs.vr.open($event);
            }
        }
    }
</script>

<style src="./VRMovies.scss" lang="scss" scoped />
